import type { CreateProviderInput, ProviderConnection } from '@emailforge/schemas';

import { apiSlice } from '@/features/api/apiSlice';

export const providersApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listProviders: b.query<ProviderConnection[], void>({
      query: () => '/providers/email',
      providesTags: ['Provider'],
    }),
    createProvider: b.mutation<{ id: string; isDefault: boolean }, CreateProviderInput>({
      query: (body) => ({ url: '/providers/email', method: 'POST', body }),
      invalidatesTags: ['Provider'],
    }),
    verifyProvider: b.mutation<{ ok: boolean; status: 'healthy' | 'down' }, string>({
      query: (id) => ({ url: `/providers/email/${id}/verify`, method: 'POST' }),
      invalidatesTags: ['Provider'],
    }),
    setDefaultProvider: b.mutation<{ ok: true }, string>({
      query: (id) => ({ url: `/providers/email/${id}/default`, method: 'POST' }),
      invalidatesTags: ['Provider'],
    }),
    deleteProvider: b.mutation<void, string>({
      query: (id) => ({ url: `/providers/email/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Provider'],
    }),
  }),
});

export const {
  useListProvidersQuery,
  useCreateProviderMutation,
  useVerifyProviderMutation,
  useSetDefaultProviderMutation,
  useDeleteProviderMutation,
} = providersApi;
